import {
    Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, Flex, Grid, GridItem, Image, Input, InputGroup, Text, Tooltip, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Select, Textarea, InputLeftElement, Popover, PopoverTrigger, PopoverContent, PopoverCloseButton, VStack, IconButton, Badge,
} from "@chakra-ui/react";
import MyDiv from "./myProject.style"
import CustomToast from "../../../components/CustomToast";
import { useFetch } from "../../../hooks/useFetch";
import { useEffect, useState, useRef } from "react";
import { AddIcon, AttachmentIcon, ChevronDownIcon, CloseIcon, EditIcon, Search2Icon, TimeIcon, ViewIcon } from "@chakra-ui/icons";
import useDebounce from "../../../hooks/useDebounce";
import { LeadHistory, MyleadHistory, MyLeadList, MyleadViewDrawer } from "../../Leads/components";
import { getStatusRank, ILead, ILeadTable } from "../../Leads/LeadPool/model";
import LeadRequirementForm from "../../Leads/components/LeadRequirementForm/leadRequirementForm";
import LeadRequirement from "../../Leads/LeadRequirement";
import CustomPagination from "../../../components/CustomPagination";
import { useAuth } from "../../../hooks/useAuth";
import FilterCard, { IFilterOptions } from "../../../components/FilterCard/filterCard";
import { useLocation, useNavigate } from "react-router-dom";
import * as routesNames from '../../../constant/routes';
import { pageMapping } from "../../../utilities/pageMapping";
import UniversalActivityHistory from "../../../components/History";
import DateRangePicker from "../../../components/DatePicker/datePicker";
import EditProjectModal from "../components/EditProjectModal";
import MyProjectList from "../components/MyProjectList/myProjectList";

const sortOptions = [
    "Latest Leads",
    "Oldest Leads",
    "Recently Updated",
    // "Follow-up Due",
    "Hot Leads First",
    // "Recently Contacted",
    // "Proposal Pending",
    // "Negotiation Stage",
    "Company Name (A-Z)",
    "Company Name (Z-A)",
];

const sortMapping: Record<
    string,
    { field: string; order: 1 | -1 }
> = {
    "Latest Leads": { field: "createdAt", order: -1 },
    "Oldest Leads": { field: "createdAt", order: 1 },
    "Recently Updated": { field: "updatedAt", order: -1 },
    // "Follow-up Due": { field: "followUpDate", order: 1 },
    "Hot Leads First": { field: "priority", order: -1 },
    // "Recently Contacted": { field: "lastContacted", order: -1 },
    // "Proposal Pending": { field: "proposalStatus", order: 1 },
    // "Negotiation Stage": { field: "leadStatus", order: 1 },
    "Company Name (A-Z)": { field: "companyName", order: 1 },
    "Company Name (Z-A)": { field: "companyName", order: -1 },
};



const MyProject = () => {
    const { addToast } = CustomToast();
    const { fetchApi } = useFetch(addToast);
    const fetchIdRef = useRef(0);
    const navigate = useNavigate();

    const getSavedState = () => {
        try {
            const saved = sessionStorage.getItem('my_leads_list_state');
            if (saved) {
                return JSON.parse(saved);
            }
        } catch (e) {
            console.error("Error reading saved leads state:", e);
        }
        return null;
    };

    const savedStateRef = useRef<any>(null);

    if (savedStateRef.current === null) {
        savedStateRef.current = getSavedState();
    }

    const savedState = savedStateRef.current;

    const [leadData, setLeadData] = useState<ILeadTable>({ leads: [], totalCount: 0 });
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState(savedState?.search ?? "");
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [viewLead, setViewLead] = useState<ILead | null>(null);
    const [isHistoryOpen, setIsHistoryOpen] = useState(false);
    const [historyLead, setHistoryLead] = useState<ILead | null>(null);
    const debounceSearch = useDebounce(search, 700);
    const { userName, hasPermission } = useAuth(); const [expandedLeadId, setExpandedLeadId] = useState<number | null>(null);
    const [totalCount, setTotalCount] = useState<number>(0);

    const [lazyParams, setLazyParams] = useState(() => {
        if (savedState?.query?.lazyParams) {
            return savedState.query.lazyParams;
        }
        return { first: 0, rows: 100, page: 0, sortField: '', sortOrder: 1, };
    });

    const [selectedSort, setSelectedSort] = useState(savedState?.selectedSort ?? sortOptions[0]);
    const [isSortOpen, setIsSortOpen] = useState(false);
    const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });
    const [maskingSettings, setMaskingSettings] = useState<any>({});
    const [selectedCard, setSelectedCard] = useState(savedState?.selectedCard ?? "");
    const [statusCounts, setStatusCounts] = useState<any[]>([]);
    const [isLegendOpen, setIsLegendOpen] = useState(false);
    const [revealedField, setRevealedField] = useState<{ rowIndex: number | null; field: string | null; }>({ rowIndex: null, field: null, });
    const [revealedRow, setRevealedRow] = useState<number | null>(null);

    const [dateRange, setDateRange] = useState<{
        start: Date;
        end: Date;
    } | null>(() => {
        if (savedState?.dateRange) {
            return {
                start: new Date(savedState.dateRange.start),
                end: new Date(savedState.dateRange.end)
            };
        }
        return null;
    });

   

    const [query, setQuery] = useState<{
        filter: Record<string, any>;
        lazyParams: {
            first: number;
            rows: number;
            page: number;
            sortField: string;
            sortOrder: number;
        };
    }>(() => {
        if (savedState?.query) {
            return savedState.query;
        }
        return {
            filter: {},
            lazyParams: { ...lazyParams },
        };
    });

    const pageCount = Math.ceil(totalCount / query.lazyParams.rows);

    const scrollLeadIdRef = useRef<number | null>(null);

    useEffect(() => {
        if (!savedState) {
            return;
        }

        if (savedState.selectedLeadId) {
            scrollLeadIdRef.current = savedState.selectedLeadId;
        }


        if (savedState.search !== undefined) {
            setSearch(savedState.search);
        }

        if (savedState.selectedSort !== undefined) {
            setSelectedSort(savedState.selectedSort);
        }

        if (savedState.selectedCard !== undefined) {
            setSelectedCard(savedState.selectedCard);
        }

        if (savedState.dateRange) {
            setDateRange({
                start: new Date(savedState.dateRange.start),
                end: new Date(savedState.dateRange.end),
            });
        }

        sessionStorage.removeItem("my_leads_list_state");
    }, []);

    useEffect(() => {
        if (!scrollLeadIdRef.current || leadData.leads.length === 0) {
            return;
        }

        const leadId = scrollLeadIdRef.current;

        const leadExists = leadData.leads.some(
            (lead: any) => lead.leadId === leadId
        );

        if (!leadExists) {
            return;
        }

        setTimeout(() => {
            const element = document.getElementById(
                `lead-row-${leadId}`
            );

            if (!element) {
                return;
            }

            element.scrollIntoView({
                behavior: "smooth",
                block: "center",
            });

            element.style.outline = "2px solid #2563EB";
            element.style.outlineOffset = "-2px";

            setTimeout(() => {
                element.style.outline = "none";
            }, 2000);

            scrollLeadIdRef.current = null;



        }, 150);
    }, [leadData.leads]);

    const [isEditProjectOpen, setIsEditProjectOpen] = useState(false);
    const [editingProject, setEditingProject] = useState<any>(null);

    const handleNavigateLeadDetail = (lead: any) => {
        const stateToSave = {
            search,
            query,
            selectedSort,
            selectedCard,
            dateRange: dateRange ? { start: dateRange.start.toISOString(), end: dateRange.end.toISOString() } : null,
            selectedLeadId: lead.leadId
        };
        sessionStorage.setItem('my_leads_list_state', JSON.stringify(stateToSave));

        navigate(routesNames.PROJECTDETAIL, {
            state: {
                fullScreen: true,
                from: routesNames.MYPROJECT,
                fromLabel: "My Project",
                lead: {
                    projectId: lead.projectId || lead.id,
                    projectAmount: lead.projectAmount,
                    projectDuration: lead.projectEstimatedDuration || lead.projectDuration,
                    projectEstimatedDuration: lead.projectEstimatedDuration || lead.projectDuration,
                    projecStartDate: lead.projectStartDate || lead.projecStartDate,
                    projectStartDate: lead.projectStartDate || lead.projecStartDate,
                    projectEndDate: lead.projectEndDate,
                    serviceType: lead.serviceType,
                    serviceInterestedIn: lead.serviceInterestedIn,
                    serviceInterestedInIds: lead.serviceInterestedInIds,
                    bdmName: lead.bdmName,
                    preSalesName: lead.preSalesName,
                    sourceName: lead.sourceName || lead.project?.sourceName,
                    projectWonDate: lead.projectWonDate || lead.wonDate,
                    leadId: lead.leadId,
                    companyId: lead.companyId || lead.project?.companyId,
                    companyName: lead.companyName || lead.projectName,
                    projectName: lead.projectName || lead.companyName,
                    pocName: lead.pocName,
                    contact: lead.contact,
                    countryCode: lead.countryCode,
                    email: lead.email,
                    assignedToUser: lead.assignedToUser,
                    leadStatus: lead.projectStatus || lead.leadStatus,
                    leadStatusId: lead.leadStatusId,
                    createdBy: lead.createdBy,
                    createdAt: lead.createdAt,
                    upcomingMeetingCount: lead.upcomingMeetingCount,
                    upcomingFollowupCount: lead.upcomingFollowupCount,
                    isAccepted: lead.isAccepted,
                },
            },
        });
    };


    const canViewAllContacts = hasPermission("MyProject", "ViewAllContact");
    const canViewOnlyContacts = hasPermission("MyProject", "ViewOnlyContact");
    const canHideContacts = hasPermission("MyProject", "HideContact");
    const canViewRowContacts = hasPermission("MyProject", "ViewRowContact");

    const toggleRequirementRow = (lead: any) => {
        setExpandedLeadId(prev => (prev === lead.leadId ? null : lead.leadId));
    }

    const handleEditLead = (row: any) => {
        setEditingProject(row);
        setIsEditProjectOpen(true);
    };


    const previousSearchRef = useRef(debounceSearch);

    useEffect(() => {
        if (previousSearchRef.current === debounceSearch) {
            return;
        }
        previousSearchRef.current = debounceSearch;

        setQuery((prev) => ({
            ...prev,
            lazyParams: {
                ...prev.lazyParams,
                first: 0,
                page: 0,
            },
        }));
    }, [debounceSearch]);



    const loadMyLeads = async () => {
        setLoading(true);
        const fetchId = ++fetchIdRef.current;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const params = new URLSearchParams({
            lazyParams: JSON.stringify(query.lazyParams), search: debounceSearch, filter: JSON.stringify(query.filter ?? {}), timeZone: timezone,
        });
        if (dateRange) {
            params.append("startDate", formatDate(dateRange.start));
            params.append("endDate", formatDate(dateRange.end));
        }
        const res = await fetchApi("Project/ShowMyProject", "GET", null, params.toString(), "");
        if (fetchId !== fetchIdRef.current) {
            return;
        }
        if (res) {
            setLeadData(res);
            setTotalCount(res.totalCount);
            const sortedCounts = [...(res.statusCounts || [])].sort((a: any, b: any) => {
                return getStatusRank(a.statusName) - getStatusRank(b.statusName);
            });
            setStatusCounts(sortedCounts);
        }
        setLoading(false);
    };



    useEffect(() => {
        loadFilter();
    }, []);

    useEffect(() => {
        loadMyLeads();
    }, [query, debounceSearch, dateRange]);

    const handleViewLead = (lead: ILead) => {
        setViewLead(lead);
        setIsViewOpen(true);
    };

    const handleHistoryLead = (lead: ILead) => {
        setHistoryLead(lead);
        setIsHistoryOpen(true);
    };


    const { loginObj } = useAuth();
    const location = useLocation();

    const loadMaskingSettings = async () => {
        const pageId = pageMapping[location.pathname] || 224;
        const roleId = loginObj?.roleId?.[0] || loginObj?.roles?.[0];
        if (!roleId) return;

        const res = await fetchApi(
            `FieldMaskingSettings/GetMaskingSettings?pageId=${pageId}&roleId=${roleId}`,
            "GET"
        );
        if (res && Array.isArray(res)) {
            const formatted: any = {};
            res.forEach((item: any) => {
                formatted[item.fieldName] = item.maskType;
            });
            setMaskingSettings(formatted);
        }
    };

    useEffect(() => {
        loadMaskingSettings();
    }, [location.pathname, loginObj]);

    const maskText = (text?: string) => {
        if (!text) return "";
        return "*".repeat(text.length);
    };


    const toggleReveal = (rowIndex: number, field: string) => {
        if (canViewOnlyContacts) {
            setRevealedField({
                rowIndex,
                field,
            });
            return;
        }
        if (canViewRowContacts) {
            setRevealedRow(rowIndex);
            return;
        }
    };


    const handlePageClick = ({ selected, }: { selected: number; }) => {
        const first = selected * query.lazyParams.rows;
        setQuery((prev) => ({
            ...prev,
            lazyParams: {
                ...prev.lazyParams,
                page: selected,
                first,
            },
        }));
    };

    const loadFilter = async () => {
        const response =
            await fetchApi<IFilterOptions>("Filters/MyLeadFilterNew", "GET", null, null, "");
        if (response) {
            if (response.filterOptions && response.filterOptions["Status"]) {
                response.filterOptions["Status"] = [...response.filterOptions["Status"]].sort((a: any, b: any) => {
                    return getStatusRank(a.name) - getStatusRank(b.name);
                });
            }
            setFilter(response);
        }
    };

    const handleSort = (option: string) => {
        setSelectedSort(option);

        const sortConfig =
            sortMapping[option];

        if (sortConfig) {
            setQuery((prev) => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    sortField: sortConfig.field,
                    sortOrder: sortConfig.order,
                    page: 0,
                    first: 0,
                },
            }));
        }
    };

    const setRowsPerPage = (rows: number) => {
        setQuery((prev: any) => {
            const updatedParams = {
                ...prev.lazyParams,
                rows,
                page: 0,
                first: 0,
            };

            return {
                ...prev,
                lazyParams: updatedParams,
            };
        });
    };

    const formatDate = (date: Date) => {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0'); // month is 0-indexed
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    }


    const handleDateRangeChange = (
        newRange: { start: Date; end: Date } | null
    ) => {
        setDateRange(prev => {
            if (prev && newRange &&
                prev.start.getTime() === newRange.start.getTime() &&
                prev.end.getTime() === newRange.end.getTime()) {
                return prev;
            }
            return newRange;
        });
    };

    return (
        <MyDiv>
            <Box className="top-section">
                <Text className="font-poppins text_xxl text_semibold">Show My Projects</Text>
                <Flex align="center" gap={3} >
                    <InputGroup width="250px">
                        <InputLeftElement pointerEvents="none">
                            <Search2Icon color="gray.500" />
                        </InputLeftElement>
                        <Input placeholder="Search by comp/poc name..." value={search} onChange={(e) => setSearch(e.target.value)} bg="white" />
                    </InputGroup>

                    <DateRangePicker
                        maxDate={new Date()}
                        onChange={handleDateRangeChange} showAdvancedFilters={false}
                    //defaultCurrentWeek
                    />
                    {/* FILTER */}
                    {/* <Text fontSize="14px" fontWeight="500">
                        Filter
                    </Text>

                    <Popover placement="bottom-start">
                        <PopoverTrigger>
                            <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="160px" justifyContent="space-between">
                                Filter
                            </Button>
                        </PopoverTrigger>

                        <FilterCard
                            filter={filter}
                            selectedFilters={query.filter}
                            onApply={(filters) => {
                                const _filter: Record<string, any> = {};
                                Object.keys(filters).forEach((key) => {
                                    if (filters[key].length > 0) {
                                        _filter[key.replace(/ /g, "")] = filters[key];
                                    }
                                });

                                if (query.filter.Ownership) {
                                    _filter.Ownership = query.filter.Ownership;
                                }

                                setQuery((prev) => ({
                                    ...prev,
                                    lazyParams: {
                                        ...prev.lazyParams,
                                        page: 0,
                                        first: 0,
                                    },
                                    filter: _filter,
                                }));
                            }}
                        />
                    </Popover> */}


                    {/* SORT */}

                    <Text fontSize="14px" fontWeight="500" whiteSpace="nowrap">
                        Sort By
                    </Text>

                    <Popover placement="bottom-start" isOpen={isSortOpen} onClose={() => setIsSortOpen(false)}>
                        <PopoverTrigger>
                            <Button rightIcon={<ChevronDownIcon />} bg="#F9FAFB" border="1px solid #D0D5DD" fontSize="14px" minW="180px" justifyContent="space-between" onClick={() => setIsSortOpen(true)} >
                                {selectedSort}
                            </Button>
                        </PopoverTrigger>

                        <PopoverContent w="240px">
                            <Box px={4} py={3} borderBottom="1px solid #E5E7EB" position="relative">
                                <Text textAlign="center" fontSize="14px" fontWeight="500">
                                    Sort By
                                </Text>
                                <PopoverCloseButton top="8px" right="12px" />
                            </Box>

                            <Box maxH="220px" overflowY="auto">
                                {sortOptions.map(
                                    (option) => (
                                        <Box key={option} px={3} py={2} cursor="pointer" bg={selectedSort === option ? "#F3F4F6" : "#FFFFFF"} _hover={{ bg: "#F9FAFB", }} onClick={() => { handleSort(option); setIsSortOpen(false); }}>
                                            <Text fontSize="14px">
                                                {option}
                                            </Text>
                                        </Box>
                                    )
                                )}
                            </Box>
                        </PopoverContent>
                    </Popover>

                </Flex>
            </Box>

            <MyProjectList
                loadMyLeads={loadMyLeads}
                maskingSettings={maskingSettings}
                leadData={leadData}
                loading={loading}
                search={search}
                setSearch={setSearch}
                toggleReveal={toggleReveal}
                maskText={maskText}
                handleEditLead={handleEditLead}
                handleViewLead={handleViewLead}
                handleHistoryLead={handleHistoryLead}
                expandedLeadId={expandedLeadId}
                toggleRequirementRow={toggleRequirementRow}
                revealedField={revealedField}
                revealedRow={revealedRow}
                canViewAllContacts={canViewAllContacts}
                canViewOnlyContacts={canViewOnlyContacts}
                canViewRowContacts={canViewRowContacts}
                canHideContacts={canHideContacts}
                onNavigateLeadDetail={handleNavigateLeadDetail}
                first={query.lazyParams.first}
            />

            <EditProjectModal
                isOpen={isEditProjectOpen}
                onClose={() => {
                    setIsEditProjectOpen(false);
                    setEditingProject(null);
                }}
                project={editingProject}
                onSuccess={loadMyLeads}
                maskingSettings={maskingSettings}
                canViewAllContacts={canViewAllContacts}
            />

            <Drawer isOpen={isHistoryOpen} placement="right" size="lg" onClose={() => setIsHistoryOpen(false)}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader>History</DrawerHeader>
                    <DrawerBody>
                        {historyLead?.leadId && (
                            <UniversalActivityHistory
                                module="Lead"
                                recordId={historyLead.leadId}
                            />
                        )}
                    </DrawerBody>
                </DrawerContent>
            </Drawer>

            {totalCount > 0 && (
                <CustomPagination
                    pageCount={pageCount}
                    handlePageClick={handlePageClick}
                    rowsPerPage={query.lazyParams.rows}
                    rowsPerPageOptions={[50, 100, 200, 500]}
                    setRowsPerPage={setRowsPerPage}
                    totalRecords={totalCount}
                    currentPage={query.lazyParams.page}
                />
            )}
        </MyDiv>
    );
};

export default MyProject;
